import { render, staticRenderFns } from "./InvestorCredit.vue?vue&type=template&id=dccc8d96&scoped=true&"
import script from "./InvestorCredit.vue?vue&type=script&lang=js&"
export * from "./InvestorCredit.vue?vue&type=script&lang=js&"
import style0 from "./InvestorCredit.vue?vue&type=style&index=0&id=dccc8d96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccc8d96",
  null
  
)

export default component.exports